function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { isObject } from './isObject';
export var deepEqual = function deepEqual(object1, object2) {
  var keys1 = Object.keys(object1);
  var keys2 = Object.keys(object2);
  if (Array.isArray(object1) && Array.isArray(object2)) {
    object1.forEach(function (currentValue, index) {
      if (_typeof(currentValue) !== _typeof(object2[index])) {
        return false;
      }
      if (!deepEqual(currentValue, object2[index])) {
        return false;
      }
    });
  }
  if (keys1.length !== keys2.length) {
    return false;
  }
  for (var _i = 0, _keys = keys1; _i < _keys.length; _i++) {
    var key = _keys[_i];
    var val1 = object1[key];
    var val2 = object2[key];
    var areObjects = isObject(val1) && isObject(val2);
    var areArrays = Array.isArray(val1) && Array.isArray(val2);
    if (areObjects && !deepEqual(val1, val2)) {
      return false;
    }
    if (!areObjects) {
      if (areArrays) {
        return deepEqual(val1, val2);
      }
      if (val1 !== val2) {
        return false;
      }
    }
  }
  return true;
};